import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { captureEvent } from '../../../../services/event-capture';
import {
  moveMapToLocation,
  selectCurrentMapCenter,
  showSelectMapPoint,
} from '../../../../services/store/modules/app-controls';
import { setLocation } from '../../../../services/store/modules/incident-report';
import LocationSelectorLayout from '../../../layouts/LocationSelectorLayout/LocationSelectorLayout';

const IncidentReportSetLocationPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const currentMapCenter = useSelector(selectCurrentMapCenter);

  const handleSelectLocation = async () => {
    await captureEvent({
      type: 'incident: location selected',
      payload: {
        selectedLatitude: currentMapCenter.lat,
        selectedLongitude: currentMapCenter.lon,
      },
      sendToAmplitude: true,
    });

    dispatch(setLocation(currentMapCenter.lat, currentMapCenter.lon));
    history.push('details');
  };

  const handleInitialState = React.useCallback(async () => {
    dispatch(
      await moveMapToLocation({
        currentMapCenter,
      }),
    );
    // don't include center as a dep as it will case the map to constantly move
    // to the users location as they move
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleBack = () => {
    captureEvent({
      type: 'incident: back to select type',
      payload: {},
      sendToAmplitude: true,
    });

    history.goBack();
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      handleInitialState();
      dispatch(showSelectMapPoint(-1)); // ;(
    }

    return () => {
      isMounted = false;
    };
  }, [dispatch, handleInitialState]);

  return (
    <LocationSelectorLayout
      onSelectLocation={handleSelectLocation}
      onBack={handleBack}
      buttonLabel="Confirm incident location"
      heading="Incident location"
      instructionText="Move map to incident location"
    />
  );
};

export default IncidentReportSetLocationPage;
